module.exports = __webpack_public_path__ + "img/no-overdraft.8c1b477e.png";